import React, { Component } from "react";
import { injectIntl } from "react-intl";
import DataTable from "react-data-table-component";

import CustomPagination from './CustomPagination';

class ReactDataTable extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    this._adjustHeaderPadding();
    // Recompute on window resize since scrollbar may appear/disappear
    if (typeof window !== "undefined") {
      window.addEventListener("resize", this._adjustHeaderPadding);
    }
  }

  componentDidUpdate() {
    this._adjustHeaderPadding();
  }

  componentWillUnmount() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this._adjustHeaderPadding);
    }
  }

  // Measure vertical scrollbar in the table body and add right padding to the header row
  _adjustHeaderPadding = () => {
    try {
      const container = this.containerRef && this.containerRef.current;
      if (!container) return;

      const headerRow = container.querySelector('.rdt_TableHead .rdt_TableHeadRow');
      const body = container.querySelector('.rdt_TableBody');
      if (!headerRow || !body) return;

      const hasVScroll = body.scrollHeight > body.clientHeight;
      const scrollbarWidth = hasVScroll ? (body.offsetWidth - body.clientWidth) : 0;

      // Apply paddingRight to the header row to compensate for the scrollbar width
      headerRow.style.paddingRight = `${scrollbarWidth}px`;
    } catch (err) {
      // silently ignore DOM measurement errors
      // console.error(err);
    }
  }

  render() {
    const { columns, data, totalRecords, rowsPerPage, className, onChangePage, ...restProps } = this.props;

    // If caller didn't pass fixedHeader props, enable fixed header and derive
    // a scroll height from className like "custom-scroll-460" so header and body
    // stay aligned when the body has a scrollbar.
    const userFixedHeader = Object.prototype.hasOwnProperty.call(restProps, "fixedHeader");
    const userFixedHeaderScrollHeight = Object.prototype.hasOwnProperty.call(restProps, "fixedHeaderScrollHeight");

    let fixedHeader = restProps.fixedHeader;
    let fixedHeaderScrollHeight = restProps.fixedHeaderScrollHeight;

    if (!userFixedHeader) {
      fixedHeader = true;
    }

    if (!userFixedHeaderScrollHeight) {
      const cls = (className || "");
      const m = cls.match(/custom-scroll-(\d+)/);
      if (m && m[1]) {
        fixedHeaderScrollHeight = `${m[1]}px`;
      }
    }

    return (
      <div ref={this.containerRef} style={{ width: '100%' }}>
        <DataTable
          className={(className || "")}
          columns={(columns || [])}
          data={(data || [])}
          paginationServer
          paginationComponent={CustomPagination}
          paginationTotalRows={totalRecords}
          paginationPerPage={rowsPerPage}
          onChangePage={onChangePage}
          persistTableHead={true}
          fixedHeader={fixedHeader}
          fixedHeaderScrollHeight={fixedHeaderScrollHeight}
          {...restProps}
        />
      </div>
    );
  };
};

export default injectIntl(ReactDataTable);
